export enum InformationalServiceBehavior {
  NeverAgainInSession,
  OverAndOverAgain,
}

export enum Behavior {
  NeverAgainInSession,
  OverAndOverAgain,
  NeverAgainInTransaction,
}
